import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { Dispatch } from 'redux-api-middleware';
import { addAccount } from 'store/api/accounts/account/accountActions';
import { submitForm } from 'store/api/submitForm/submitForm';
import { AddAccountResponse } from 'store/api/types';

import { Sidebar } from './Sidebar';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onAddAccount: submitForm<AddAccountResponse>(dispatch, addAccount),
});

export const SidebarContainer = withRouter(
  compose(
    connect(
      undefined,
      mapDispatchToProps,
    ),
  )(Sidebar),
);
